module.exports = __webpack_public_path__ + "static/API-code-54b01bbfd9e7e8592570daeaae506f30.png";